import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function AssignTestDialog({ product, brand, open, onClose, fixedPatient }) {
  const [patients, setPatients] = useState([]);
  const [patientId, setPatientId] = useState(fixedPatient?.id || "");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (!fixedPatient) api.get("/patients").then((r) => setPatients(r.data)).catch(() => {}); }, [fixedPatient]);

  const submit = async () => {
    if (!patientId) return toast.error("Select a patient");
    setBusy(true);
    try {
      await api.post("/marketplace/assign", { patient_id: patientId, product_id: product.id, note: note || null });
      toast.success(`${product.name} recommended`);
      onClose(true);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="bg-white" data-testid="assign-test-dialog">
        <DialogHeader><DialogTitle className="font-heading">Recommend {product.name}</DialogTitle><DialogDescription>Create a test recommendation linked to a patient.</DialogDescription></DialogHeader>
        <div className="space-y-4">
          <p className="text-sm text-slate-600">From <b>{brand.name}</b>{product.price ? ` · ${product.price}` : ""}. This creates a recommendation the patient and care team can track.</p>
          {fixedPatient ? (
            <p className="text-sm"><span className="text-slate-500">Patient:</span> <b>{fixedPatient.name}</b></p>
          ) : (
            <div><Label>Patient</Label>
              <Select value={patientId} onValueChange={setPatientId}>
                <SelectTrigger data-testid="assign-patient-select"><SelectValue placeholder="Select a patient" /></SelectTrigger>
                <SelectContent className="bg-white max-h-64">{patients.map((p) => <SelectItem key={p.id} value={p.id} data-testid={`assign-patient-${p.id}`}>{p.name}</SelectItem>)}</SelectContent>
              </Select>
            </div>
          )}
          <div><Label>Note for the patient (optional)</Label><Textarea data-testid="assign-note-input" value={note} onChange={(e) => setNote(e.target.value)} placeholder="e.g. Please book this within 2 weeks." /></div>
          <div className="flex justify-end gap-2 pt-2">
            <Button variant="outline" onClick={() => onClose()} data-testid="assign-cancel">Cancel</Button>
            <Button className="bg-teal-700 hover:bg-teal-800 rounded-full" disabled={busy} onClick={submit} data-testid="assign-confirm">{busy ? "Assigning…" : "Recommend test"}</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
